<template>
    <rkm-modal
        extraLarge
        hide-header
        persistent
        ref="RkmModal"
    >
        <rkm-area
            title="Paciente"
            type="fieldset"
            no-margin-top
        >
            <rkm-row>
                <rkm-col class="flex-grow-1">
                    <rkm-row>
                        <rkm-col>
                            <h4>
                                {{fechamento.pacienteNome}}
                            </h4>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="3">
                            <p>
                                <strong>Prontuário:</strong>
                                {{fechamento.prontuario}}
                            </p>
                            <p>
                                <strong>Telefone:</strong>
                                {{ fechamento.telefone }}
                            </p>
                            <p>
                                <strong>Sexo:</strong>
                                {{fechamento.sexo}}
                            </p>
                        </rkm-col>

                        <rkm-col cols="3">
                            <p>
                                <strong>CPF:</strong>
                                 <template v-if="fechamento.cpf">
                                    {{ fechamento.cpf }}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </p>
                            <p>
                                <strong>Data de nascimento:</strong>
                                {{fechamento.dataNascimento}}
                            </p>
                            <p>
                                <strong>Nome da mãe:</strong>
                                <template>
                                    {{fechamento.nomeMae}}
                                </template>
                            </p>
                        </rkm-col>

                        <rkm-col>
                            <p>
                                <strong>CNS:</strong>
                                <template v-if="fechamento.cns">
                                    {{ fechamento.cns }}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </p>
                            <p>
                                <strong>
                                   Idade:
                                </strong>
                                 <template v-if="fechamento.idade">
                                    {{ fechamento.idade.anos }} anos,
                                    {{ fechamento.idade.meses }} meses e
                                    {{ fechamento.idade.dias }} dias
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </p>
                            <p>
                                <strong>Unidade de referência:</strong>
                                {{fechamento.unidadeReferencia}}
                            </p>
                        </rkm-col>

                    </rkm-row>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            class="mt-4"
            title="Dados do exame"
            type="fieldset"
            no-margin-top
        >
            <rkm-col class="flex-grow-1">
                <rkm-row>
                    <rkm-col cols="4">
                        <p>
                            <strong>Número do agendamento:</strong>
                            {{fechamento.agendamentoNumero}}
                        </p>
                        <p>
                           <strong>Grupo de exame: </strong>
                            {{fechamento.grupoExame}}
                        </p>
                        <p>
                            <strong>Responsável:</strong>
                            <template v-if="fechamento.nomeResponsavel"> {{fechamento.nomeResponsavel}}</template>
                            <template v-else> - </template>
                        </p>
                    </rkm-col>
                    <rkm-col cols="4">
                        <p>
                            <strong>Data do exame: </strong>
                            {{fechamento.data}}
                        </p>
                        <p>
                            <strong>Exame: </strong>
                            {{fechamento.exameNome}}
                        </p>
                        <p>
                            <strong>Unidade executante:</strong>
                            {{fechamento.unidadeExecutante}}
                        </p>
                    </rkm-col>
                    <rkm-col cols="4">
                        <p>
                            <strong>Pedido com urgência: </strong>
                            <template v-if="fechamento.urgente == true">Sim</template>
                            <template v-else>Não</template>
                        </p>
                        <p>
                            <strong>Profissional: </strong>
                            {{fechamento.profissionalNome}}
                        </p>
                        <p>
                            <strong>Médico solicitante: </strong>
                            {{fechamento.medicoNome}}
                        </p>
                    </rkm-col>
                </rkm-row>
            </rkm-col>
        </rkm-area>

        <template v-slot:footer=" {cancel}">
            <rkm-button
                :label="false"
                color="secondary"
                @click="cancel"
                class="mt-0 mr-2 float-right"
            >
                Voltar
            </rkm-button>
        </template>

    </rkm-modal>
</template>

<script>

// Mixins.
import { error, repository, data } from '@/mixins'

// Filters.
import formats from '@/filters/formats'

export default {
    created() {
        this.repositories = {
            jornada: this.getConectaSusRepository('exameImagem.jornada')
        }
    },
    data: () => ({
        items: [],
        selected: '',
        fechamento: {
            agendamentoNumero: null,
            cpf: null,
            cns: null,
            data: null,
            dataNascimento: null,
            exameNome: '',
            grupoExame: '',
            idade: {
                anos: '',
                meses: '',
                dias: '',
            },
            medicoNome: '',
            nomeMae: '',
            nomeResponsavel: '',
            pacienteNome: '',
            prontuario: null,
            profissionalNome: '',
            sexo: '',
            telefone: '',
            unidadeReferencia:'',
            unidadeExecutante:'',
        },
    }),
    filters: {
        formatDate: formats.formatDate,
        formatCns: formats.formatCns,
        formatCpf: formats.formatCpf,
    },
    methods: {
        open(item) {

            this.fechamento.agendamentoNumero = item.agendamento.agendamentoNumero
            this.fechamento.cpf = item.agendamento.paciente.cidadao.cpf
            this.fechamento.cns = item.agendamento.paciente.cidadao.cns
            this.fechamento.data = item.agendamento.data
            this.fechamento.dataNascimento = this.getFormatedDate(item.agendamento.paciente.cidadao.dataNascimento, 'DD/MM/YYYY'),
            this.fechamento.exameNome = item.exameNome
            this.fechamento.grupoExame = item.agendamento.grupoExame
            this.fechamento.idade = item.agendamento.paciente.cidadao.idade
            this.fechamento.medicoNome = item.agendamento.medicoNome
            this.fechamento.nomeMae = item.agendamento.paciente.cidadao.nomeMae
            this.fechamento.nomeResponsavel = item.agendamento.nomeResponsavel
            this.fechamento.pacienteNome = item.agendamento.pacienteNome
            this.fechamento.prontuario = item.agendamento.prontuario
            this.fechamento.profissionalNome = item.agendamento.profissionalNome
            this.fechamento.sexo = item.agendamento.paciente.cidadao.sexo.descricao
            this.fechamento.telefone = item.agendamento.paciente.cidadao.telefonePrincipal.numero
            this.fechamento.unidadeReferencia = item.agendamento.paciente.unidade.nomeFantasia
            this.fechamento.unidadeExecutante = item.agendamento.unidadeNome
            this.fechamento.urgente = item.agendamento.urgente

            this.items = []
            this.$refs.RkmModal.show()
        },
    },
    mixins: [ error, repository, data ],
    props: {
        data: { type: Object, required: true },
    },
}
</script>

<style scoped>

p {
    margin: 0px;
}
.col-svg {
    text-align: center !important;
}
.icon {
    width: auto !important;
    height: 96px !important;
    color: #007bff !important;
}
</style>
